var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
// eslint-disable
/** bean: begin */
export * from '../bean/bean.behavior.js';
export * from '../bean/bean.behaviorBase.js';
export * from '../bean/bean.behaviorsHolder.js';
import 'zova';
/** bean: end */
/** bean: begin */
import { BeanBehavior } from '../bean/bean.behavior.js';
import { BeanBehaviorsHolder } from '../bean/bean.behaviorsHolder.js';
import 'zova';
/** bean: end */
/** service: begin */
export * from '../service/composer.js';
import 'zova-module-a-bean';
/** service: end */
/** service: begin */
import { ServiceComposer } from '../service/composer.js';
import 'zova';
/** service: end */
/** controller: begin */
export * from '../component/behavior/controller.jsx';
import 'zova';
/** controller: end */
/** controller: begin */
import { ControllerBehavior } from '../component/behavior/controller.jsx';
import 'zova';
/** controller: end */

/** components: begin */
export * from './component/behavior.js';
import { ZBehavior } from './component/behavior.js';
export const components = {
  'behavior': ZBehavior
};
import 'zova';
/** components: end */
/** behavior: begin */
export * from '../bean/behavior.root_.js';
import 'zova-module-a-behavior';
/** behavior: end */
/** behaviors: begin */
import 'vue';
import 'vue/jsx-runtime';
/** behaviors: end */
/** scope: begin */
import { BeanScopeBase } from 'zova';
import { Scope } from 'zova-module-a-bean';
export let ScopeModuleABehavior = (_dec = Scope(), _dec2 = __z_BeanInfo({
  module: "a-behavior"
}), _dec(_class = _dec2(_class = class ScopeModuleABehavior extends BeanScopeBase {}) || _class) || _class);
import 'zova';

/** scope: end */